export default __webpack_public_path__ + "static/media/business-problem1.f77e7008.png";